import React from "react";
import styled from "styled-components";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import AddressInput from "views/Status/Subscribers/FilteringControls/AddressInput";
import PolicyInput from "./PolicyInput";
import useProfile from "common/hooks/useProfile";
import useFilter from "common/hooks/useFilter";

const _defaultSettings = {
  lines: 100000,
  policy: "all",
  source: "all",
  subnet: "",
};

const _linesOptions = [
  { label: "100", value: 100 },
  { label: "1000", value: 1000 },
  { label: "10000", value: 10000 },
  { label: "100000", value: 100000 },
  { label: "1000000", value: 1000000 },
];
const _sourceOptions = [
  { value: "all", label: "All assignment sources" },
  { value: "billing", label: "Assigned by billing", exceptPlaform: "gs-kr" },
  { value: "rest", label: "Assigned by REST" },
  { value: "radius", label: "Assigned by RADIUS", exceptPlaform: "gs-kr" },
  { value: "rules", label: "Assigned by rules" },
  { value: "config", label: " Assigned by config  " },
];

const applyPlatormFilter =
  (profile) =>
  ({ platform, exceptPlaform }) =>
    platform !== undefined
      ? profile.platform === platform
      : exceptPlaform !== undefined
      ? profile.platform !== exceptPlaform
      : true;

const ControlsAndResultsLayout = styled.div`
  flex: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const viewUrl = 'viewSubscriberAttributes';

const FilteringControls = ({ defaults = {}, subnet = undefined, policy = undefined, children }) => {
  defaults = {
    ..._defaultSettings,
    ...defaults,
    ...(subnet === undefined ? {} : { subnet }),
    ...(policy === undefined ? {} : { policy }),
  };
  const profile = useProfile();
  const [settings, onChange, onChangeValue] = useFilter(viewUrl, defaults);

  return profile === null ? null : (
    <ControlsAndResultsLayout>
      <ColumnsGrid columns={4} minWidth="15rem" gap="3rem" rowGap="0">
        <SelectInputWithIcon
          title="Lines"
          name="lines"
          icon="format_line_spacing"
          selected={settings.lines}
          onChange={onChange}
          options={_linesOptions}
        />
        <PolicyInput
          selected={settings.policy}
          name="policy"
          onChange={(value, name) => onChangeValue(value, "policy")}
        />
        <SelectInputWithIcon
          title="Sources"
          name="source"
          icon="settings"
          selected={settings.source}
          onChange={onChange}
          options={_sourceOptions.filter(applyPlatormFilter(profile))}
        />
        <AddressInput
          value={settings.subnet}
          name="subnet"
          onChange={onChange}
        />
      </ColumnsGrid>
      {children(settings)}
    </ControlsAndResultsLayout>
  );
};
export default FilteringControls;
